import React, { useContext, useEffect, useState } from "react";
import { JSDCContext, JSDCProvider } from "jsdc-dui/dist/JSDC/Context";
import JSDC from "jsdc-dui/dist/JSDC";
import { latLng, latLngBounds } from "leaflet";
import {
  IDuiContextProviderProps,
  DuiContextProvider,
} from "jsdc-dui/dist/components/Context";
import DguideWalksApp from "jsdc-dui/dist/components/DguideWalksApp";
import { DguidewalksProvider } from "jsdc-dui/dist/JSDC/Dguidewalks/Context";
import "jsdc-dui/dist/style/index.css";
import "./index.scss";
import ConfigProvider from "jsdc-dui/dist/JSDC/Dguidewalks/ConfigProvider";
import headerImg from "./assets/key-art_Desktop.png";
import headerImgMb from "./assets/key-art_mobile.jpg";
import aboutImg from "./assets/about.png";
//* fuck
// import Hambarger from "jsdc-dui/dist/components/Icons/Hamburger"

//TODO: EVENT_ID
const EVENT_ID = "n0029";

//TODO: aboutWalkContent
const aboutWalkContent = `本「礁溪數位走讀地圖」由佛光大學人文暨社會科學學院戴榮冠老師攜手114年第一學期大一國文課程同學共同完成，參與協作之同學（依照組別排序）共計有李宸嘉、楊凱婷、陳元恩、張邵宸、高承佑、楊翰廷、葉侑茹、劉慶適、釋慧緣、蔡嘉朗、林芷芸、簡素枝、郭芳羚、孫永冠、釋悟覺、陳芃廷、江仲旗、王婕瑜、陳彥竹、薛品均、陳明書、張云甄、黃曉惠、楊語政、陳晏鋐、王巨中、釋慧諭、甄彩雲、許家羚等29位同學。本地圖以佛家「身土不二」為核心理念，延伸至人文數位地景創作，將在地踏查與文史研究結合，打造出一份能被閱讀、被行走、也能被深度體驗的數位人文作品。透過分組協作，學生走入礁溪的山徑、街巷與水岸，在採集資料、比對史料與運用數位工具的過程中，更加理解土地與人的互動脈絡，並在知識、情感與技能等三層次獲得全面成長。
本次走讀精選十處具有代表性的礁溪文化景點，包含佛光大學、林美石磐步道、五峰旗瀑布風景區、跑馬古道、抹茶山、湯圍溝溫泉公園、礁溪協天廟、武暖石板橋、吳沙故居、龍潭湖等十個景點，藉由上述景點，串聯出礁溪獨有的自然紋理與人文故事。透過本地圖的導引，期盼使用者在漫步山海之際，不僅欣賞自然之美，更能從歷史記憶與在地文化中，看見礁溪深沉而細膩的生命脈動，展開一場真正屬於自己的深度人文之旅。`;

const credit = `
<div>
     團隊介紹：佛光大學人文暨社會科學學院，聯絡電話(03)9871000#23001
    <br>
    <br>本圖臺是由佛光大學人文暨社會科學學院及智紳數位文化事業有限公司共同協力建置：
    <br>
    <br>1. 圖臺內容：佛光大學人文暨社會科學學院
    <br>
    <br>2. 圖臺系統開發：智紳數位文化事業有限公司
    <br>
    <br>除另有聲明外，本網站其他內容內容採用創用 CC 姓名標示-非商業性-相同方式分享4.0授權條款授權公眾使用，您可以依授權條款複製、引用、轉載，唯請於合理位置標示：佛光大學人文暨社會科學學院 <a href="https://chss.fgu.edu.tw/" target="_blank" style="color: #f2660d">https://chss.fgu.edu.tw/</a>
</div>	
`;

const duiConfigProps: IDuiContextProviderProps = {
  sidebarTitle: "",
  sidebarSubtitle: "",
  aboutWalkImgSrc: aboutImg,
  aboutWalkContent,
  credit,
  creditHref: "https://www.facebook.com/JRSHENDigitalCulture/",
  headerMBImgSrc: headerImgMb,
  headerDImgSrc: headerImg,
  menuSwitchItems: [{ id: "數位集章", name: "數位集章" }],
  weatherConfig: {
    token: "CWB-232A270E-12F1-4381-B9F2-DF2D2670A077",
    locations: [{ county: "宜蘭縣", town: "礁溪鄉" }], //TODO: weather 氣象預測地點
  },
  themeConfig: {
    "--dui-primary": "#f2660d", //TODO: theme
    "--dui-accent": "#563ca0", //TODO: 數位集章按鈕顏色
    "--dui-secondary": "#f2660d", //TODO: theme
    "--dui-bg-secondary": "#C9B189", // Dialog background
    "--dui-bg-accent": "#4193ac", //TODO: background
  },
  settingConfig: {
    disabled: true, // 左側選單不出現「工具設定」
    // languageSwitcherDisabled: true, // 或：保留「工具設定」，只藏語言切換器
  },
};
// #e4e7cb
// 景點的 icon、點擊開集章卡片、cluster、集章 key、`?id=` 深連結、
// 列表的定位與導航、底圖、線都由 jsdc-dui 依 Strapi 的資料建立，這裡不需要再處理圖層。
function App() {
  const { Jsdc } = useContext(JSDCContext);

  useEffect(() => {
    (window as any).JSDC = Jsdc;
  }, [Jsdc]);

  return (
    <div className="root">
      <DguideWalksApp
      language="zh-TW"
      // ! 左側數位集章選項
      // mainMenuChildren={
      //   <MenuItemWithDialog
      //     Icon={Checkin}
      //     title="路線顏色"
      //     active={dui.activeMenuId === "數位集章"}
      //     {...dui.menuSwitcherAction("數位集章")}
      //   >
      //     {/* {dui.activeMenuId === "數位集章" && (
      //   <iframe
      //     style={{ height: "100%", border: 0, borderRadius: "5px" }}
      //     src={`https://map.jsdc.com.tw/tools/checkin/${EVENT_ID}/showlist.php?a=${EVENT_ID}`}
      //   ></iframe>
      // )} */}
      //     {paths.map((path) => (
      //       <div
      //         key={path.name}
      //         style={{
      //           display: "flex",
      //           alignItems: "center",
      //           margin: "20px",
      //         }}
      //       >
      //         <div
      //           style={{
      //             width: "50px",
      //             height: "5px",
      //             backgroundColor: path.color,
      //             alignItems: "center",
      //             marginRight: "10px",
      //           }}
      //         ></div>
      //         <span
      //           style={{
      //             fontSize: "20px",
      //             color: "#000",
      //             // fontWeight: "bold",
      //           }}
      //         >{` ：${path.name}`}</span>
      //       </div>
      //     ))}
      //   </MenuItemWithDialog>
      // }
      />
    </div>
  );
}

const config = new ConfigProvider({ eventId: EVENT_ID });

const AppWrapper: React.FC = () => {
  const [Jsdc] = useState(
    new JSDC(EVENT_ID, {
      bound: latLngBounds(
        //TODO: map view bound
        latLng(24.8459111, 121.6659397),
        latLng(24.7884236, 121.8382478)
      ),
      maxZoom: 20,
    })
  );

  return (
    <JSDCProvider Jsdc={Jsdc}>
      <DguidewalksProvider
        Jsdc={Jsdc}
        layerLegendImages={{
          "國土利用現況調查成果圖 Land Use Type Map":
            "https://maps.nlsc.gov.tw/demo/105RGB%E8%89%B2%E7%A2%BC%E8%A1%A8.png",
          "1904-日治臺灣堡圖(明治版)-1:20,000 Japanese Taiwan Map (1904)-1:20,000":
            "https://gis.sinica.edu.tw/legend/JM20K_1904/",
          "1921-日治臺灣堡圖(大正版)-1:20,000 Japanese Taiwan Map (1921)-1:20,000":
            "https://gis.sinica.edu.tw/legend/JM20K_1904/",
          "1944-日治地形圖(航照修正版)-1:25,000 Japanese Topographic Map (1944)-1:25,000":
            "https://gissrv4.sinica.edu.tw/gis/img/legend/legend_25k-50k_1917.htm",
        }}
        config={config}
      >
        <DuiContextProvider {...duiConfigProps}>
          <App />
        </DuiContextProvider>
      </DguidewalksProvider>
    </JSDCProvider>
  );
};

export default AppWrapper;
